import { useRouteMatch } from 'react-router';

import * as RouteNames from '../constants/RouteNames';

const useIsProfileRoute = () => {
    return !!useRouteMatch([ RouteNames.Profile, RouteNames.NotificationSettings, RouteNames.PrivacyAndSecuritySettings ]);
};

export default useIsProfileRoute;
